import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegistrationActivityDatasource } from '../../views/registration_transactions/datasources/registration_activity_datasource';
angular
  .module('capability-ng-scheduler')
  .factory(
    'registrationErrorDismissCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      log: any,
      ngRegistrationActivityDatasource: IRegistrationActivityDatasource
    ) => {
      return defineCommandORM(
        'registrationErrorDismissCommand',
        (deferred: ng.IDeferred<IQuery[]>, activityId: number) => {
          $http
            .delete(`reg/activity/${activityId}/`)
            .then(() => {
              const activityToBeDismissed = ngRegistrationActivityDatasource.get(activityId);
              if (activityToBeDismissed) {
                ngRegistrationActivityDatasource.del(activityToBeDismissed.id);
              }
              deferred.resolve();
            })
            .catch((e) => {
              log.issue('Failed to dismiss the registration activity.');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_errors/commands/registration_error_dismiss_command.ts